import { Input } from '@cian/ui-kit';
import * as React from 'react';

import { IconOk, IconVk } from './icons';
import * as style from './style.css';

export interface ISharingPopupProps {
  url: string;
  onClick: (social: 'vk' | 'ok') => void;
}

export const SharingPopup: React.FC<ISharingPopupProps> = ({ url, onClick }) => {
  return (
    <div>
      <div className={style['social-links']}>
        <div data-testid="VkSocialLink" className={style['vk']} onClick={() => onClick('vk')}>
          <IconVk />
        </div>
        <div data-testid="OkSocialLink" className={style['ok']} onClick={() => onClick('ok')}>
          <IconOk />
        </div>
      </div>

      <div className={style['input-link']}>
        <Input value={url} readOnly />
      </div>
    </div>
  );
};
